import { AlertTriangle, CheckCircle2, HelpCircle } from 'lucide-react';
import { cn } from '../../utils/cn';
import type { VerificationCheckItem } from '../../types';

// Mirrors the SOP's "Checking the Output" table exactly - same 5 lines, same distinction
// between a blocking check (the SOP says answer "n" if missing) and the one advisory
// check (Google Drive token - the SOP says continue and re-authorise, not abort).
export function VerificationChecklist({ checks }: { checks: VerificationCheckItem[] }) {
  return (
    <div className="space-y-2">
      {checks.map((check) => (
        <div
          key={check.id}
          className={cn(
            'flex items-start gap-2.5 rounded-lg border px-3 py-2.5 text-sm',
            check.found === true
              ? 'border-pulse-200 bg-pulse-50 dark:border-pulse-900/40 dark:bg-pulse-900/10'
              : check.found === false && check.severity === 'blocking'
                ? 'border-rose-200 bg-rose-50 dark:border-rose-900/40 dark:bg-rose-900/10'
                : 'border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-800/40',
          )}
        >
          {check.found === true ? (
            <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-pulse-600 dark:text-pulse-400" />
          ) : check.found === false && check.severity === 'blocking' ? (
            <AlertTriangle size={16} className="mt-0.5 shrink-0 text-rose-500" />
          ) : (
            <HelpCircle size={16} className="mt-0.5 shrink-0 text-slate-400" />
          )}
          <div className="min-w-0">
            <p className="font-medium text-slate-800 dark:text-slate-100">
              {check.label}
              {check.severity === 'advisory' && (
                <span className="ml-1.5 text-[10px] font-normal uppercase tracking-wide text-slate-400">advisory</span>
              )}
            </p>
            <p className="text-xs text-slate-500 dark:text-slate-400">{check.meaning}</p>
            {check.found === false && (
              <p className="mt-0.5 text-xs font-medium text-rose-600 dark:text-rose-400">
                Not seen in the output yet {check.severity === 'blocking' ? '- the SOP says answer "n" if this is genuinely missing.' : '- continue, then re-authorise Google Drive.'}
              </p>
            )}
            {check.matchedLine && <p className="mt-0.5 truncate font-mono text-[11px] text-slate-400">{check.matchedLine}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
